// See https://docs.google.com/spreadsheets/d/13tfpOeoHN4r7uT5tLBxQ5MgKGdcmIcGrksNTzlpRjsk/edit#gid=765642249 "Lilly" tab for calculation details
export const CHAPTER_COUNT_BY_KEY_MAP: Map<string, number> = new Map([
    // new|old|sourceType
    ['GHDP|GHDP|Textbook', 23],
    ['GHDP|GHFV-US|Textbook', 2],
    ['GHDP|NEW|Textbook', 4],
    ['GHDP|GHDP|StudyNote', 9],
    ['GHDP|NEW|StudyNote', 3],
    ['GHDP|GHFV-US|Asop', 1],
    ['GHDP|GHDP|Website', 7],
    ['GHDP|GHFV-US|Website', 1],
    ['GHDP|GHDP|Asop', 5],
    ['GHDP|NEW|Website', 1],
    ['GHRM|GHDP|Textbook', 6],
    ['GHRM|GHDP|StudyNote', 10],
    ['GHRM|GHDP|Website', 5],
    ['GHRM|GHSPC|Textbook', 10],
    ['GHRM|NEW|Textbook', 1],
    ['GHRM|NEW|StudyNote', 2],
    ['GHRM|GHSPC|Website', 3],
    ['GHRM|GHSPC|StudyNote', 2],
    ['GHRM|GHSPC|Asop', 3],
    ['GHRM|GHFV-US|Website', 1],
    ['GHVR-US|GHFV-US|Textbook', 11],
    ['GHVR-US|GHFV-US|StudyNote', 8],
    ['GHVR-US|GHFV-US|Asop', 10],
    ['GHVR-US|GHFV-US|Website', 3],
    ['GHVR-US|NEW|StudyNote', 1],
    ['GHVR-US|NEW|Website', 3],
    ['GHVR-US|NEW|Textbook', 1],
    ['GHVR-US|GHSPC|StudyNote', 1],
    ['REMOVED|GHDP|StudyNote', 5],
    ['REMOVED|GHDP|Website', 3],
    ['REMOVED|GHFV-US|StudyNote', 14],
    ['REMOVED|GHFV-US|Asop', 3],
    ['REMOVED|GHFV-US|Website', 7],
    ['REMOVED|GHSPC|StudyNote', 10],
    ['REMOVED|GHSPC|Textbook', 6],
    ['REMOVED|GHSPC|Asop', 3],
    ['REMOVED|GHSPC|Website', 1],
])
